export const FULL_SCREEN_POPUP_STYLES = {
  width: '100%',
  height: '100%',
  maxWidth: '100vw',
  maxHeight: '100vh',
};
